export const productName = 'SURGICAL INSTRUMENTATION TEACHER READY';
export const productShortName = 'Surgical Instrumentation Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/8hhWnUQzYstLK6qDKBK6c2/MOCKUP_9.49.37_a._m..png';

export const checkoutUrl = 'https://surgical-instrumentation-teacher-ready.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Fundamentals of Surgical Instrumentation & Operating Room Practice',
  'Volume 2 — Surgical Instruments: Classification, Identification & Functions',
  'Volume 3 — Aseptic Techniques, Sterility & Infection Prevention',
  'Volume 4 — Surgical Procedures & Perioperative Workflow',
  'Volume 5 — Surgical Anatomy & Medical Terminology for Educators',
  'Volume 6 — Surgical Instrument Processing, Sterilization & Safety',
  'Volume 7 — Specialized Surgical Instrumentation Across Medical Disciplines',
  'Volume 8 — Operating Room Management, Patient Safety & Professional Practice',
  'Volume 9 — Teaching Surgical Instrumentation',
  'Bonus 1 — 150 Teaching Activities & Challenges',
  'Bonus 2 — Surgical Instrumentation Teacher Assessment Kit',
  'Bonus 3 — 100 Case Studies & Problem-Solving Scenarios',
  'Bonus 4 — Surgical Instrumentation Teacher Dictionary: 200 Essential Concepts',
  'Bonus 5 — Surgical Instrumentation Teacher Lesson Planning Guide (50 Lesson Structures)',
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex surgical instrumentation concepts',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see surgical instrumentation's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
